var underscoreMin = {
  exports: {}
};

export { underscoreMin as u };
//# sourceMappingURL=underscore-min.js.map
